// extracted by mini-css-extract-plugin
export default {"string":"Stat_string__5tps5"};